module.exports = __webpack_public_path__ + "media/images/massage/malika@3x-2cb22d59b0dc9545e149d3240b21e4a2.jpg";